import React, { useCallback } from 'react';
import { useGetHeaderHeight } from '@carnica/smart-kit';
import { clientOnlyHook } from '@beef/utils';

// смещаем блок таб-бара на фикс значение
const DELTA_OFFSET = 24;

const _useCalculateTransformStyle = (sectionRef: React.RefObject<HTMLDivElement>): string => {
  const headerHeight = useGetHeaderHeight();
  return useCallback(() => {
    const sectionHeight = sectionRef.current?.getBoundingClientRect()?.height ?? 0;
    const offset = Math.max(0, window.innerHeight - sectionHeight - headerHeight + DELTA_OFFSET);
    const sectionPositionY = window.scrollY > 0 ? 0 : offset;

    return `translate(-50%, -${sectionPositionY}px)`;
  }, [sectionRef, headerHeight])();
};

export const useCalculateTransformStyle = clientOnlyHook(_useCalculateTransformStyle);
